<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13,0C13,0,3,0,3,0C2.45,0,2,0.45,2,1C2,1,2,15,2,15C2,15.55,2.45,16,3,16C3,16,13,16,13,16C13.55,16,14,15.55,14,15C14,15,14,1,14,1C14,0.45,13.55,0,13,0C13,0,13,0,13,0ZM6,14C6,14,4,14,4,14C4,14,4,12,4,12C4,12,6,12,6,12C6,12,6,14,6,14C6,14,6,14,6,14ZM6,11C6,11,4,11,4,11C4,11,4,9,4,9C4,9,6,9,6,9C6,9,6,11,6,11C6,11,6,11,6,11ZM6,8C6,8,4,8,4,8C4,8,4,6,4,6C4,6,6,6,6,6C6,6,6,8,6,8C6,8,6,8,6,8ZM9,14C9,14,7,14,7,14C7,14,7,12,7,12C7,12,9,12,9,12C9,12,9,14,9,14C9,14,9,14,9,14ZM9,11C9,11,7,11,7,11C7,11,7,9,7,9C7,9,9,9,9,9C9,9,9,11,9,11C9,11,9,11,9,11ZM9,8C9,8,7,8,7,8C7,8,7,6,7,6C7,6,9,6,9,6C9,6,9,8,9,8C9,8,9,8,9,8ZM12,14C12,14,10,14,10,14C10,14,10,9,10,9C10,9,12,9,12,9C12,9,12,14,12,14C12,14,12,14,12,14ZM12,8C12,8,10,8,10,8C10,8,10,6,10,6C10,6,12,6,12,6C12,6,12,8,12,8C12,8,12,8,12,8ZM12,5C12,5,4,5,4,5C4,5,4,2,4,2C4,2,12,2,12,2C12,2,12,5,12,5C12,5,12,5,12,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Calculator',
} as DefineComponent
</script>
